"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLandFilters = void 0;
var _filters = require("../filters");
var _types = require("../filters/types");
var _validateAddress = require("../../repositories/price-estimator/v1/validate-address");
/**
 * Валидатор фильтров для типа оцениваемой недвижимости "Дома"
 * Проверяет наличие обязательных полей, соответствие их условиям
 * Отправляет запрос к АПИ, валидируя адрес
 * */
const validateLandFilters = () => async (dispatch, getState, context) => {
  const state = getState();
  const {
    filters: {
      address,
      landArea
    }
  } = state;
  if (!address) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.address,
      errorText: 'Укажите адрес'
    }));
    return false;
  }
  if (!landArea) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.landArea,
      errorText: 'Укажите площадь участка'
    }));
    return false;
  }
  if (landArea > 9999) {
    dispatch((0, _filters.setError)({
      currentErrorField: _types.ECurrentErrorField.landArea,
      errorText: 'Недопустимое значение'
    }));
    return false;
  }
  try {
    const response = await (0, _validateAddress.fetchValidateAddress)({
      httpApi: context.httpApi,
      parameters: {
        address
      }
    });
    if (response.statusCode === 400) {
      const errors = response.response.errors || [];
      const error = errors[0] || {};
      const {
        key,
        message
      } = error;
      if (key && message) {
        dispatch((0, _filters.setError)({
          currentErrorField: key,
          errorText: message
        }));
      }
      return false;
    }
    if (!response.response.isValid) {
      dispatch((0, _filters.setError)({
        currentErrorField: _types.ECurrentErrorField.address,
        errorText: 'Оцениваем дома только в Москве и МО'
      }));
      return false;
    }
    if (response.response.houseId) {
      dispatch((0, _filters.setHouseId)({
        houseId: response.response.houseId
      }));
    }
  } catch (e) {
    context.logger.error('Unable to validate suburban land address', e);
    return false;
  }
  return true;
};
exports.validateLandFilters = validateLandFilters;